import React, {FC} from 'react';
import styled from 'styled-components';

import asana16 from '../../../../../../libs/shared/assets/src/images/asana16.svg';
import github16 from '../../../../../../libs/shared/assets/src/images/github16.svg';
import jira16 from '../../../../../../libs/shared/assets/src/images/jira16.svg';
import {Icon} from '../../../../../../libs/shared/ui/src/components/icon/icon';
import {useUserTheme} from '../../../../../../libs/shared/ui/src/theme/userThemeProvider';
import {getPreviewerEmojiDefinition} from '../../../../../models/api/previewerHelpers';
import {PreviewerLinkTypesEnum, RPreviewerLinkTypesEnum} from '../../../../../models/api/previewerModel';
import {Emoji} from '../../../../common/emoji/emoji';

/*
 * Props.
 */

interface SearchSuggestionsDropdownBusinessObjectItemIconProps {
  type: PreviewerLinkTypesEnum | string;
}

/*
 * Styles.
 */

const StyledImageWrapperDiv = styled.div`
  display: flex;
`;

const StyledImg = styled.img`
  height: 16px;
  width: 16px;
`;

/*
 * Component.
 */

export const SearchSuggestionsDropdownBusinessObjectItemIcon: FC<
  SearchSuggestionsDropdownBusinessObjectItemIconProps
> = (props) => {
  const {type} = props;

  const theme = useUserTheme();

  if (RPreviewerLinkTypesEnum.is(type)) {
    const emoji = getPreviewerEmojiDefinition(type);

    if (emoji) {
      return <Emoji emoji={emoji.emoji} skinTone={emoji.skinTone} size={16} />;
    }
  }

  switch (type) {
    case 'asana': {
      return (
        <StyledImageWrapperDiv>
          <StyledImg src={asana16} alt={type} />
        </StyledImageWrapperDiv>
      );
    }

    case 'github': {
      return (
        <StyledImageWrapperDiv>
          <StyledImg src={github16} alt={type} />
        </StyledImageWrapperDiv>
      );
    }

    case 'jira': {
      return (
        <StyledImageWrapperDiv>
          <StyledImg src={jira16} alt={type} />
        </StyledImageWrapperDiv>
      );
    }

    default: {
      // TODO(flav 2023-01-04): Replace with the right icon.
      return <Icon name="karlitoSmall" color={theme.greys.shade70} />;
    }
  }
};
